<div class="view-head">
  <div class="row">

    <div class="col-12 d-none d-md-block col-md-3">
      <h2>Payment processors</h2>
    </div>

  </div>
</div>
<div class="tabs-wrap">
  <app-mobile-tabs #mobileTabs (onSelected)="onSelectTab($event)" selectedValue="caxton">
    <ul>
      <li><a class="selected" (click)="mobileTabs.onSelectItem('caxton', $event)">Caxton</a>
      <li><a (click)="mobileTabs.onSelectItem('nmible', $event)">Nmible</a></li>
    </ul>
  </app-mobile-tabs>


  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': selectedTab == 'caxton'}" data-toggle="tab"
        (click)="onSelectTab('caxton')">Caxton</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': selectedTab == 'nmible'}" data-toggle="tab"
        (click)="onSelectTab('nmible')">Nmible</a>
    </li>
  </ul>
</div>

<div class="tab-content" id="details-view-tab-content">

  @if (selectedTab === 'caxton') {
  <div class="view-body" *ngIf="subsidiaryPaymentDetailsViewModel">

    <div class="content-panel payment-content">
      <table class="simple-form payments-form">
        <tr *ngIf="subsidiaryPaymentDetailsViewModel.caxtonAccountDetails">
          <th style="width: 140px;"><label>Caxton Payment Reference</label></th>
          <td>
            <div class="form-group caxton-balance-wrapper">
              <input type="text" class="form-control trial-payment-info" disabled
                [value]="subsidiaryPaymentDetailsViewModel.caxtonAccountDetails.caxtonPaymentReference">
            </div>
          </td>
        </tr>
        <tr *ngIf="subsidiaryPaymentDetailsViewModel.caxtonAccountDetails">
          <th style="width: 140px;"><label>Caxton Owner Email</label></th>
          <td>
            <div class="form-group caxton-balance-wrapper">
              <input type="text" class="form-control trial-payment-info" disabled
                [value]="subsidiaryPaymentDetailsViewModel.caxtonAccountDetails.caxtonOwnerEmail">
            </div>
          </td>
        </tr>
        <tr
          *ngIf="subsidiaryPaymentDetailsViewModel.caxtonBalances && subsidiaryPaymentDetailsViewModel.caxtonBalances.length">
          <th style="width: 140px;"><label for="">Currency Balances</label></th>
          <td>
            <div class="form-group caxton-balance-wrapper">
              <input
                *ngIf="subsidiaryPaymentDetailsViewModel.caxtonBalances && subsidiaryPaymentDetailsViewModel.caxtonBalances.length"
                type="text" class="form-control caxton-balance trial-payment-info" disabled
                [value]="subsidiaryPaymentDetailsViewModel.caxtonBalances[0].balance">
              <span>{{subsidiaryPaymentDetailsViewModel.caxtonBalances[0].currency}}</span>
            </div>
          </td>
        </tr>
        <tr
          *ngFor="let balance of subsidiaryPaymentDetailsViewModel.caxtonBalances && subsidiaryPaymentDetailsViewModel.caxtonBalances.length > 1 ? subsidiaryPaymentDetailsViewModel.caxtonBalances.slice(1) : []">
          <th style="width: 140px;"></th>
          <td>
            <div class="form-group caxton-balance-wrapper">
              <input type="text" class="form-control caxton-balance trial-payment-info" disabled
                [value]="balance.balance">
              <span>{{balance.currency}}</span>
            </div>
          </td>
        </tr>
        <tr
          *ngIf="subsidiaryPaymentDetailsViewModel.caxtonBalances && subsidiaryPaymentDetailsViewModel.caxtonBalances.length">
          <th style="width: 140px;"></th>
          <td>
            <div class="form-group payment-buttons">
              <button [disabled]="textConnectionIsProcessing" type="submit" class="btn btn-outline"
                (click)="testConnectionToCaxton()">
                <img src="../../../assets/img/icon _ refresh.svg" alt="Refresh">
                <span *ngIf="textConnectionIsProcessing">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span class="sr-only">Loading...</span>
                </span>
                <span *ngIf="!textConnectionIsProcessing">Refresh</span>
              </button>
              <button (click)="getBalanceAlerts()"
                [disabled]="!authService.hasPermission(Permissions.TrialPaymentsCaxton)" class="btn btn-secondary">
                <img src="../../../assets/img/icon _ alerts.svg" alt="Alerts">Alerts
              </button>
              <button (click)="showArchiveEmptyWalletsModal()"
                [disabled]="!authService.hasPermission(Permissions.CaxtonCardWrite)" class="btn btn-secondary">
                Archive Empty Wallets
              </button>
            </div>
          </td>
        </tr>

        <tr *ngIf="isDevelopmentEnv">
          <th style="width: 140px;" class="qa-testing-label"><label for="testWalletName">QA Testing</label></th>
          <td class="qa-testing-cell">
            <div class="qa-testing-row">
              <input type="text" id="testWalletName" class="form-control qa-testing-input" #testWalletNameInput
                placeholder="Test wallet name">
              <button (click)="createTestWalletOnParentSubsidiary(testWalletNameInput.value)"
                [disabled]="creatingTestWallet || !authService.hasPermission(Permissions.CaxtonCardWrite)"
                class="btn btn-secondary qa-testing-button">
                <span *ngIf="creatingTestWallet">
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span class="sr-only">Loading...</span>
                </span>
                <span *ngIf="!creatingTestWallet">Create Empty Wallet (Parent Subsidiary)</span>
              </button>
            </div>
            <p class="qa-testing-note">
              Creates an empty, unlinked wallet on the parent subsidiary so the <strong>Archive Empty Wallets</strong>
              sweep has something to find. The sweep will not archive it on the first run - a wallet must be seen empty
              and unlinked on two runs at least 24 hours apart before it is archived. Untick <strong>Dry run</strong> on
              the first sweep: a dry run reports what it sees but does not start the 24 hour clock. The outcome is in the
              sweep summary email, not on this page.
            </p>
          </td>
        </tr>
      </table>
    </div>
  </div>
  }

  @if (selectedTab === 'nmible') {

  }
</div>



<app-modal #alertsModal [customClassName]="'alerts-modal'">
  <div class="modal-header">
    <i (click)="alertsModal.hide()" class="icon-cancel" aria-hidden="true"></i>
    <h2 class="modal-title">Currency Balance Alerts</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="alertForm">
      <div class="alert-columns">
        <label class="label">Current Balance</label>
        <label class="label">Alert at</label>
      </div>
      <div *ngFor="let balanceThreshold of balanceThresholds" class="form-group alert-balances">
        <label class="currency-label" [for]="balanceThreshold.currency">
          {{balanceThreshold.currentBalance}}
          {{balanceThreshold.currency}}
        </label>
        <div class="input-wrapper">
          <input type="number" [id]="balanceThreshold.currency" [formControlName]="balanceThreshold.currency"
            [value]="balanceThreshold.balance">
        </div>
      </div>
      <div class="form-group alert-email">
        <label for="alertEmail" class="label">Alert to:</label>
        <input id="alertEmail" formControlName="alertEmail" type="email">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <a (click)="alertsModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
      </div>
      <div class="col-6">
        <button class="btn btn-primary" (click)="updateAlerts()" [ngClass]="{'disabled': !alertForm.valid}">
          <span *ngIf="alertUpdateProcessing">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <span class="sr-only">Loading...</span>
          </span>
          <span *ngIf="!alertUpdateProcessing">Save</span>
        </button>
      </div>
    </div>
  </div>
</app-modal>

<app-modal-v2 #archiveEmptyWalletsModal [customClassName]="'archive-empty-wallets-modal'">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Archive Empty Wallets</h2>
    </div>
    <div class="modal-body">
      <p>Scans every subsidiary for empty, unlinked Caxton wallets and archives them. Wallets still linked to a
        patient are flagged for manual review, never archived automatically.</p>
      <p class="archive-empty-wallets-note">This is a long-running operation and can take up to 30 minutes. A report will
        be emailed to <strong>{{ subsidiaryPaymentDetailsViewModel?.walletSweepAlertEmail }}</strong> once it completes.</p>
      <form [formGroup]="archiveEmptyWalletsForm">
        <app-checkbox formControlName="dryRun" label="Dry run (preview only - don't archive)"></app-checkbox>
      </form>
    </div>
    <div class="modal-footer archive-empty-wallets-footer">
      <div class="row">
        <div class="col-6">
          <a (click)="archiveEmptyWalletsModal.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</a>
        </div>
        <div class="col-6">
          <button class="btn btn-primary" [disabled]="archivingEmptyWallets" (click)="archiveEmptyWallets()">
            <span *ngIf="archivingEmptyWallets">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span class="sr-only">Loading...</span>
            </span>
            <span *ngIf="!archivingEmptyWallets">Run</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</app-modal-v2>

<app-modal-v2 #noAlertEmailModal [customClassName]="'no-alert-email-modal'">
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Archive Empty Wallets</h2>
    </div>
    <div class="modal-body">
      <p>No alert email is configured for this subsidiary, so the sweep report has nowhere to be sent. Please contact
        IT support to have an alert email configured before running the sweep.</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-12">
          <a (click)="noAlertEmailModal.hide()" class="btn btn-primary" data-dismiss="modal">OK</a>
        </div>
      </div>
    </div>
  </div>
</app-modal-v2>